// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"9e2854c5","385":"ea4486e1"}[chunkId] + ".chunk.js";
};